<div class="flex container flex--space-between">
  <ng-container
    *ngTemplateOutlet="
      promoBanner;
      context: {
        image: compensateImage$,
        translationPrefix: 'compensateFlight',
        url: chooseUrl$ | async,
        show: true
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      promoBanner;
      context: {
        image: sustainableTravelImage$,
        translationPrefix: 'sustainableTravel',
        url: 'sustainableTravel.link.url' | finLocalization,
        show: (loggedIn$ | async) === LoginStatus.NOT_LOGGED_IN
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      promoBanner;
      context: {
        image: donatePointsImage$,
        translationPrefix: 'donatePoints',
        url: finnairShopDonateUrl,
        show: (loggedIn$ | async) === LoginStatus.LOGGED_IN
      }
    "
  >
  </ng-container>
</div>

<ng-template #promoBanner let-image="image" let-translationPrefix="translationPrefix" let-linkUrl="url" let-show="show">
  <div
    class="white-bg border rounded-large mr-xsmall-t overflow-hidden flex flex--column fill banner-card mr-xsmall-r"
    *ngIf="show"
  >
    <div class="image-wrapper relative flex" *ngIf="image | async as imageData">
      <fcom-image
        [ratio]="aspectRatio$ | async"
        [scale]="false"
        [imageData]="imageData"
        [fillParent]="true"
      ></fcom-image>
    </div>

    <div class="pr-small flex flex-1 flex--column fill" [attr.data-test-banner]="translationPrefix">
      <div class="flex flex-1 flex--column">
        <h2 class="font-heading-4 nordic-blue-900-text ms-xsmall-b">
          {{ translationPrefix + '.title' | finLocalization }}
        </h2>
        <p>
          {{ translationPrefix + '.text' | finLocalization }}
        </p>
      </div>
      <div class="flex flex--end">
        <a
          [href]="linkUrl"
          class="btn ms-medium-t no-underline font-body-1 bold-type"
          rel="noopener noreferrer"
          target="_blank"
          (click)="trackPromoBanner(translationPrefix)"
        >
          {{ translationPrefix + '.button' | finLocalization }}
        </a>
      </div>
    </div>
  </div>
</ng-template>
